import {gql} from "@apollo/client";

export const GET_ORDER_LISTING_FOR_PICKUP = gql`
    query GetOrderListingForPickup($filters: OrderWithPickupInfoFiltersTypeInput, $pageRequest: PageRequestTypeInput, $hubId: Long!) {
        getOrderListingForPickup(filters: $filters, pageRequest: $pageRequest, hubId: $hubId) {
            content {
                id
                trackingNumber
                channelId
                deliverAt
                overallStatus
                createdAt
                pickupInfo {
                    id
                    orderId
                    pickupAppointmentId
                    expectedPickupDate
                    actualPickupDate
                    pickupStatus
                }
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface OrderPickupInfo {
    id: number;
    orderId: number;
    pickupAppointmentId?: number;
    expectedPickupDate?: string;
    actualPickupDate?: string;
    pickupStatus?: string;
    pickupNotes?: string;
    createdAt: string;
    updatedAt: string;
}

export interface AvailableOrderType {
    id: number;
    trackingNumber: string;
    channelId?: number;
    deliverAt?: string;
    overallStatus: string;
    createdAt?: string;
    pickupInfo?: OrderPickupInfo;
}

export interface GetOrderListingForPickupResponse {
    getOrderListingForPickup: {
        content: AvailableOrderType[];
        page: number;
        size: number;
        totalElements: number;
        totalPages: number;
        hasNext: boolean;
        hasPrevious: boolean;
    };
}

export interface GetOrderListingForPickupVariables {
    filters?: {
        trackingNumbers?: string;
        channelId?: number;
        createdAt?: {
            start: string;
            end: string;
        };
        recipientZipcode?: string[];
        overallStatus?: string;
        expectedPickupDateRange?: {
            start: string;
            end: string;
        };
        expectedPickupTimeStart?: string;
        expectedPickupTimeEnd?: string;
    };
    pageRequest?: {
        page: number;
        size: number;
        sortBy?: string;
        sortDirection?: string;
    };
    hubId: number;
} 